/*! Copyright (c) Safe As Milk. All rights reserved. */
import Cart from "cart-store";

class ProductForm extends HTMLElement {
    #boundSubmit;
    #eventAttached;
    static #formsBeingProcessed=[];
    constructor() {
        super();
        this.#boundSubmit = this.submit.bind(this);
    }
    connectedCallback() {
        this.#eventAttached = false;
        setTimeout((() => {
            this.form = this.querySelector("form");
            this.idInput = this.form.querySelector('input[name="id"]');
            this.submitButton = this.form.elements.add;
            this.stagedAction = this.querySelector("staged-action");
            this.idInput.removeAttribute("disabled");
            this.notifyOnAdd = this.hasAttribute("notify-on-add");
            this.redirectOnAdd = this.getAttribute("redirect-on-add");
            this.#eventAttached = true;
            this.form.addEventListener("submit", this.#boundSubmit);
        }));
    }
    disconnectedCallback() {
        if (this.#eventAttached) {
            this.#eventAttached = false;
            this.form.removeEventListener("submit", this.#boundSubmit);
        }
    }
async submit(e) {
    e.preventDefault();
    const data = new FormData(e.target);
    const item = Object.fromEntries(data.entries());
    const warranty_added = document.querySelector('.warranty-checkbox');
    
    try {
        this.removeError();
        if (this.redirectOnAdd && !ProductForm.#formsBeingProcessed.includes(this.form.id)) {
            ProductForm.#formsBeingProcessed.push(this.form.id);
        }
        if (this.stagedAction) await this.stagedAction.setState("DOING");
        
        // Add the main product
        await Cart.add(item);
        
        // Only add warranty if checkbox is checked AND this is NOT a recommended product
        if (warranty_added && warranty_added.checked) {
            try {
                // Fetch current cart to check if warranty already exists
                const cartResponse = await fetch('/cart.js');
                const cart = await cartResponse.json();
                
                // Fetch the warranty product data
                const response = await fetch('/products/lifetime-warranty.js');
                const warrantyProduct = await response.json();
                
                const warrantyVariantIds = warrantyProduct.variants.map(v => v.id);
                
                // Check if warranty is already in cart
                const warrantyInCart = cart.items.some(item => 
                    warrantyVariantIds.includes(item.variant_id)
                );
                
                if (!warrantyInCart) {
                    const warrantyVariant = warrantyProduct.variants.find(v => v.available);
                    
                    if (warrantyVariant) {
                        console.log('Adding warranty variant ID:', warrantyVariant.id);
                        const warrantyItem = {
                            id: warrantyVariant.id,
                            quantity: 1
                        };
                        await Cart.add(warrantyItem);
                        console.log('Warranty added successfully');
                    }
                } else {
                    console.log('Warranty already in cart, not adding another');
                }
            } catch (warrantyError) {
                console.error('Error adding warranty:', warrantyError);
            }
        }
        
        if (this.redirectOnAdd) {
            ProductForm.#formsBeingProcessed = ProductForm.#formsBeingProcessed.filter((id => id !== this.form.id));
            if (ProductForm.#formsBeingProcessed.length === 0) {
                window.location.href = this.redirectOnAdd;
            }
        }
        if (this.stagedAction) await this.stagedAction.setState("DONE");
        const quickShop = this.closest("quick-shop");
        if (quickShop) {
            await quickShop.close();
        }
        if (this.notifyOnAdd) {
            await Cart.resetVariantsBeingAdded();
            if (!this.closest(".modal--cart")) {
                const cart = document.querySelector(".modal--cart, .popup--cart-notification");
                if (cart && !cart.shown) {
                    cart.open();
                } else if (cart && cart.interval) {
                    cart.interval.reset();
                    cart.interval.start();
                }
            }
        } else {
            await Cart.resetLatestAddedProduct();
            await Cart.resetVariantsBeingAdded(item.id);
        }
    } catch (error) {
        this.#renderError(error.message);
        if (this.stagedAction) await this.stagedAction.setState("IDLE");
        if (this.redirectOnAdd) {
            ProductForm.#formsBeingProcessed = ProductForm.#formsBeingProcessed.filter((id => id !== this.form.id));
        }
    }
}
    removeError() {
        const error = this.querySelector(".errors");
        if (!error) return;
        error.remove();
    }
    #renderError(message) {
        this.removeError();
        if (this.submitButton) {
            const error = document.createElement("div");
            error.classList.add("errors", "qty-error", "u-small");
            error.innerHTML = message;
            this.submitButton.before(error);
        }
    }
}

customElements.define("product-form", ProductForm);
//# sourceMappingURL=product-form.js.map
